"use strict";

(function () {
  function r(e, n, t) {
    function o(i, f) {
      if (!n[i]) {
        if (!e[i]) {
          var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
        }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
          var n = e[i][1][r];return o(n || r);
        }, p, p.exports, r, e, n, t);
      }return n[i].exports;
    }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
      o(t[i]);
    }return o;
  }return r;
})()({ 1: [function (require, module, exports) {
    'use strict';

    (function () {
      if (!window.wp || !window.wp.blocks || !window.wp.editor) {
        console.log('HTMLPress - Gutenberg editor not found');
        return;
      }

      var block_fonts = window.htmlpress_block_fonts;

      wp.hooks.addFilter('kadence.typography_options', 'htmlpress/blocks', function (options) {
        return [{
          type: 'group',
          label: 'Site Fonts',
          options: block_fonts || []
        }];
      });

      var block_styles = window.htmlpress_block_styles;

      if (Array.isArray(block_styles)) {
        block_styles.forEach(function (style) {
          console.log('registerBlockStyle', style);
          wp.blocks.registerBlockStyle(style.block_name, style);
        });

        wp.hooks.addFilter('blocks.registerBlockType', 'htmlpress/blocks', function (settings, name) {
          console.log('registerBlockType', name, settings);

          if ((name === 'core/button' || name === 'core/pullquote' || name === 'core/blockquote') && Array.isArray(settings.styles)) {
            settings.styles = [];
          }

          if (!Array.isArray(settings.styles) || settings.styles.length < 1) {
            if (block_styles.some(function (s) {
              return s.block_name === name;
            })) {
              settings.styles = [];
            } else {
              return settings;
            }
          }

          if (!settings.styles.some(function (style) {
            return style.isDefault;
          }) && !block_styles.some(function (style) {
            return style.isDefault && style.block_name === name;
          })) {
            settings.styles.unshift({ name: "default", label: "Default", isDefault: true });
          }

          return settings;
        });
      }
    })();
  }, {}] }, {}, [1]);